/**
 * @generated SignedSource<<b2afd92f91de159c465fe31e788ccf26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useEnabledDashboards_query$data = {
  readonly dashboards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly key: string;
        readonly title: string;
      };
    }>;
  };
  readonly " $fragmentType": "useEnabledDashboards_query";
};
export type useEnabledDashboards_query$key = {
  readonly " $data"?: useEnabledDashboards_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEnabledDashboards_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterElement"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEnabledDashboards_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filterElement"
        }
      ],
      "concreteType": "DashboardConnection",
      "kind": "LinkedField",
      "name": "dashboards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DashboardEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Dashboard",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8f59aba024126baa7f175e0232b63119";

export default node;
